let tmcv = null;
export function getTmcv() {
	if (tmcv == null) {
		tmcv = localStorage.getItem('xs_tmcv');
	}
	return tmcv;
}
